export default __webpack_public_path__ + "static/media/icon-social-link.a48129cb.svg";